import { DATE_FORMATS } from '../../../../constants';
import { format, startOfDay } from 'date-fns/esm';

export function dateMinValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: createLinkFunction(
      'uDateMin',
      (value, attrValue) => value >= attrValue
    ),
  };
}

export function dateMaxValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: createLinkFunction(
      'uDateMax',
      (value, attrValue) => value <= attrValue
    ),
  };
}

function createLinkFunction(attrName, comparison) {
  return (scope, element, attr, ctrl) => {
    if (!ctrl) {
      return;
    }

    let attrValue;

    attr.$observe(attrName, value => {
      // Expect attribute value to be a Date object
      attrValue = scope.$eval(value);
      ctrl.$validate();
    });

    ctrl.$validators[attrName] = (modelValue, viewValue) => {
      const value = modelValue || viewValue;
      return !value || !attrValue
        ? true
        : comparison(toDate(value), toDate(attrValue));
    };
  };
}

function toDate(date) {
  return angular.isDate(date)
    ? date
    : startOfDay(format(date, DATE_FORMATS.ISO_8601));
}
